import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  registerLocaleData,
} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import '@angular/compiler';
import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideMarkdown } from 'ngx-markdown';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  NoPreloading,
  provideRouter,
  RouteReuseStrategy,
  withHashLocation,
  withPreloading,
} from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthInterceptor } from '@sia/auth';
import {
  JsonDateInterceptor,
  ServiceWorkerUpdateService,
  SiaCacheInterceptor,
} from '@sia/shared';
import { AppComponent } from './app/app.component';
import { ROUTES } from './app/app.routes';
import { environment } from './environments/environment';

export class DefaultRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null,
  ): void {
    // Do nothing to prevent storing detached routes
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return curr.routeConfig === future.routeConfig;
  }
}

registerLocaleData(localeIt);

if (environment.production) {
  console.log = () => {};
}
enableProdMode();

bootstrapApplication(AppComponent, {
  providers: [
    DatePipe,
    DecimalPipe,
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      ServiceWorkerModule.register(
        `combined-sw.js?v=${environment.buildTimestamp}`,
        {
          enabled: environment.production,
          registrationStrategy: 'registerWhenStable:30000',
        },
      ),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SiaCacheInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi: true },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, disableClose: false },
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideMarkdown(),
    provideRouter(
      ROUTES,

      withHashLocation(),
      withPreloading(NoPreloading),
    ),
    {
      provide: RouteReuseStrategy,
      useClass: DefaultRouteReuseStrategy,
    },
    ServiceWorkerUpdateService,
  ],
}).catch((err) => console.error(err));
